module.exports = __webpack_public_path__ + "static/alisha_pic-02e3dbacb17cde11a9a14415a3458b56.jpg";